import { Component, Input, OnInit } from '@angular/core';
import {
	AbstractControl,
	FormBuilder,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators,
} from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { format } from 'date-fns';
import { AuthService, FormService } from 'src/app/services';

@Component({
	selector: 'app-cohorts-edit',
	templateUrl: './cohorts-edit.component.html',
	styleUrls: ['./cohorts-edit.component.scss'],
})
export class CohortsEditComponent implements OnInit {
	@Input() jobfair: any;
	@Input() isCreate: boolean = false;
	@Input() isUpdate: boolean = false;
	// fairForm!: FormGroup;

	public isLoading = false;

	isSubmitted = false;
	editForm = new FormGroup({
		id: new FormControl(0),
		name: new FormControl('', [Validators.required, Validators.maxLength(50)]),
		description: new FormControl('', [
			Validators.required,
			Validators.maxLength(100),
		]),
		price: new FormControl('', [Validators.required]),
		visible: new FormControl<boolean | null>(false),
		typeForm: new FormControl('', [
			Validators.pattern(
				'(?:(?:(?:ht|f)tp)s?://)?[\\w_-]+(?:\\.[\\w_-]+)+([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?',
			),
		]),
	});

	editFormErrorMessages = {
		name: [
			{ type: 'required', message: 'Course Name is required' },
			{
				type: 'maxLength',
				message: 'Course Name should be less than 50 characters',
			},
		],
		price: [{ type: 'required', message: 'Price is required' }],
		description: [
			{ type: 'required', message: 'Description is required' },
			{
				type: 'maxLength',
				message: 'Description should be less than 100 characters',
			},
		],
		// typeFormFormId: [{ type: 'required', message: 'Typeform ' }],
	};
	constructor(
		public popoverController: PopoverController,
		public formService: FormService,
		private authService: AuthService,
		public formBuilder: FormBuilder,
	) {}

	public ngOnInit(): void {
		if (this.isUpdate) {
			this.editForm.patchValue({
				...this.jobfair,
				// jobFairDate: format(this.jobfair.jobFairDate, 'yyyy-MM-dd HH:mm'),
				// endDate: format(this.jobfair.endDate, 'yyyy-MM-dd HH:mm'),
			});
		}
	}

	// public dateValidator(input: any) {
	// 	if (!input.root || !input.root.controls) {
	// 		return null;
	// 	}
	// 	function toTimestamp(strDate: any) {
	// 		var datum = Date.parse(strDate);
	// 		return datum / 1000;
	// 	}

	// 	let start = toTimestamp(input.root.controls.jobFairDate.value);
	// 	let end = toTimestamp(input.root.controls.endDate.value);

	// 	const valid = start >= end;

	// 	return valid ? null : { notvalid: true };
	// }

	public close() {
		this.popoverController.dismiss();
	}
	// JobfairUpdate(editForm) {
	onSubmit(editForm: any) {
		// if (!this.isLoading) {
		// 	this.isLoading = true;
		// 	// console.log(editForm.value.jobFairDate >= editForm.value.endDate);
		// 	this.formService.markFormGroupTouched(editForm);
		// 	// if (editForm.value.jobFairDate >= editForm.value.endDate) {
		// 	// 	this.authService.addToastMsg(
		// 	// 		'End time should be greater than start time.',
		// 	// 	);
		// 	// 	this.isLoading = false;
		// 	// 	return;
		// 	// }
		// 	console.log(editForm, 'form ');
		// 	if (editForm.status !== 'VALID') {
		// 		this.isLoading = false;
		// 		this.authService.addToastMsg('Please fill missing detail.');
		// 		return;
		// 	}
		// 	if (!editForm.value?.eventUrl?.includes('http')) {
		// 		editForm.value.eventUrl = 'https://' + editForm.value.eventUrl;
		// 	}
		// 	if (this.isUpdate) {
		// 		this.jobfairService
		// 			.updateJobFairListData(editForm.value.id, {
		// 				...editForm.value,
		// 				jobFairDate: new Date(editForm.value.jobFairDate).getTime(),
		// 				endDate: new Date(editForm.value.endDate).getTime(),
		// 			})
		// 			.subscribe((success: any) => {
		// 				this.isLoading = false;
		// 				this.reloadProfile();
		// 			});
		// 	} else if (this.isCreate) {
		// 		this.jobfairService
		// 			.addJobfair({
		// 				...editForm.value,
		// 				id: null,
		// 				jobFairDate: new Date(editForm.value.jobFairDate).getTime(),
		// 				endDate: new Date(editForm.value.endDate).getTime(),
		// 			})
		// 			.subscribe(success => {
		// 				this.isLoading = false;
		// 				this.ngrxService.resetState('job', 'fairs');
		// 				this.jobfairService.loadJobFairListData().subscribe();
		// 				this.reloadProfile();
		// 			});
		// 	}
		//}
	}
	reloadProfile() {
		this.close();
	}
}
